import { Card, Col, Row, Separator, Skeleton } from '@repo/ui/components'
import { Fragment } from 'react'

export const DashboardMarketSummarySkeleton = () => {
  const cards = Array.from({ length: 2 })
  const items = Array.from({ length: 3 })
  return (
    <Row className='gap-sm md:gap-lg w-full flex-wrap'>
      {cards.map((_, cIdx) => (
        <Card
          key={cIdx}
          className='!p-md w-full sm:flex-1 min-w-[calc(33.33%-16px)] !py-xl min-h-[355px]'
        >
          <Skeleton className='pb-xs w-32 h-6 rounded mb-xs' />
          <Col>
            {items.map((_, iIdx) => (
              <Fragment key={iIdx}>
                {iIdx > 0 && <Separator className='my-sm' />}
                <Row className='justify-between items-center py-sm'>
                  <Col className='gap-2xs'>
                    <Skeleton className='w-20 h-4 rounded mb-1' />
                    <Skeleton className='w-16 h-4 rounded' />
                  </Col>
                  <Col className='items-end gap-2xs'>
                    <Skeleton className='w-14 h-5 rounded mb-1' />
                    <Skeleton className='w-20 h-4 rounded' />
                  </Col>
                </Row>
              </Fragment>
            ))}
          </Col>
        </Card>
      ))}
    </Row>
  )
}
